<template>
    <van-popup
        v-model="visibleDialog"
        position="bottom"
        closeable
        close-icon="close"
        @close='onClose'
        :closeOnClickModal='false'
        :round="true"
    >
        <div class="conpon">
            <div class="head f32 col333 textCenter">商品资料</div>
            <div class="means">
                <div class="meanLi" v-for="item in goodsAttrList" :key="item.id" @click="onMeanUrl(item)" >
                    <div class="meanLeft">
                        <img src="../../../../../assets/img/b2b/icon_pdf@2x.png" alt="">
                    </div>
                    <div class="meanRight" v-text="item.name">
                        大金家用中央空调系统设计报告.pdf
                    </div>
                </div>
            </div>
        </div>
    </van-popup>
</template>

<script>
import { versions } from '../../../../common/version'
export default {
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        goodsAttrList: {
            type: Array,
            default: () => {
                return []
            }
        }
    },
    computed: {
        // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
        visibleDialog: {
            get () {
                return this.visible
            },
            set () {
                this.$emit('update:visible')
            }
        }
    },
    methods: {
        onClose () {
            this.$emit('update:visible')
        },
        onMeanUrl (obj) {
            let shareUrl = obj.url
            let shareTitle = obj.name
            let content = '海量资料免费看，还支持分享哦～'
            let logoUrl = 'https://hosjoy-oss-test.oss-cn-hangzhou.aliyuncs.com/images/20191031/508075c3-67ef-47bf-84d4-7409fddd69f0.png'
            if (versions().ios || versions().iPhone || versions().iPad) {
                window.webkit.messageHandlers.dfxB2b.postMessage({
                    'method': 'pdfShare',
                    'url': shareUrl,
                    'title': shareTitle,
                    'content': content,
                    'logoUrl': logoUrl
                })
            } else {
                window.kfxt.pdfShare(shareUrl, shareTitle, content, logoUrl)
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.conpon {
    .head {
        line-height: 80px;
    }
    .means {
        height: 900px;
        padding: 32px;
        overflow: auto;
        .meanLi {
            display: flex;
            justify-content: flex-start;
            font-size: 28x;
            color: #333333;
            line-height: 84px;
            height: 84px;
            margin-bottom: 40px;
            .meanLeft {
                flex: 0 0 72px;
                font-size: 0;
            }
            .meanRight {
                margin-left: 20px;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 1;
                overflow: hidden;
                white-space: normal;
                word-break: break-all;
            }
        }
    }
    span {
        position: relative;
        height: 44px;
        line-height: 44px;
        display: inline-block;
        background: #fff1ec;
        padding: 0 12px;
        margin-right: 16px;
        border-top: 1px solid #ff7a45;
        border-bottom: 1px solid #ff7a45;
        color: #ff4d4f;
        &::before {
            position: absolute;
            content: "";
            left: 0;
            top: 0;
            bottom: 0;
            width: 5px;
            height: 44px;
            background: url("../../../../../assets/img/b2b/conponBg_01.png")
                no-repeat;
            background-size: 100%;
        }
        &::after {
            position: absolute;
            content: "";
            right: 0;
            top: 0;
            bottom: 0;
            width: 5px;
            height: 44px;
            background: url("../../../../../assets/img/b2b/conponBg_02.png")
                no-repeat;
            background-size: 100%;
        }
    }
}
/deep/ .van-popup__close-icon {
    font-size: 40px;
}
</style>